import type { TreeMenuItem } from "@refinedev/core";

/**
 * Resolves the active top-level group for a selected menu key.
 *
 * Returns the top-level item with children that the selected key belongs to,
 * or the top-level item itself if it is a group with children. Returns null
 * for top-level leaves or unknown keys.
 */
export function findActiveGroup(
  selectedKey: string | undefined,
  menuItems: TreeMenuItem[],
): TreeMenuItem | null {
  if (!selectedKey) return null;

  for (const item of menuItems) {
    const hasChildren = (item.children?.length ?? 0) > 0;
    if (!hasChildren) continue;

    if (item.key === selectedKey) return item;
    if (item.children?.some((c) => c.key === selectedKey)) return item;
  }

  return null;
}
